import React, { ReactNode } from 'react'
import { StyledWrapper } from './styles';

interface Props {
	children: ReactNode
}
export const Wrapper = ({children}:Props) => {
	return (
		<StyledWrapper>
			{children}
		</StyledWrapper>
	)
}
